module.exports = __webpack_public_path__ + "img/swagger.b01afa1f.png";